<!-- JinnahFeedbackContent.vue -->
<template>
  <section
    class="flex flex-col items-center justify-center w-full h-[90vh] px-4 bg-transparent overflow-auto"
  >
    <!-- Profile Section -->
    <div class="profile-section flex flex-col items-center text-center">
      <img
        src="@/assets/img/jinnah.jpg"
        alt="JINNAH T. ENUMERABLES"
        class="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full border-4 border-gray-300 mb-4 object-cover"
      />
      <h1 class="text-lg sm:text-xl md:text-2xl font-bold text-white">
        JINNAH T. ENUMERABLES
      </h1>
      <h2 class="text-sm sm:text-base md:text-lg text-white mb-5">
        Administrative Officer V
      </h2>
    </div>

    <!-- Text + Image Section -->
    <div
      class="flex flex-col-reverse xl:flex-row items-center xl:items-stretch justify-center gap-6 xl:gap-10 mt-6 md:mt-8 w-full max-w-6xl"
    >
      <!-- Text Section -->
      <div class="flex-1 bg-transparent flex items-start justify-center">
        <p
          class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
        >
          Prior to the creation of the DNSC Supply Information System (SIS), the
          majority of our work in the Supply and Property Management Unit — from
          preparing documents and recording received items to issuing items and
          tracking property accountability — was done manually. Finding old
          records or tracking the movement of items was particularly
          time-consuming, as we had to review documents again to ensure that
          everything matched. It often took days to complete reports and meet
          deadlines due to the volume of paperwork that needed to be managed.
        </p>
      </div>

      <!-- Image Section -->
      <div class="flex-1 flex justify-center items-stretch">
        <img
          src="@/assets/img/jinnah-1.jpg"
          alt="JINNAH T. ENUMERABLES"
          class="w-full lg:h-[300px] h-full rounded-2xl border-2 border-gray-300 object-cover shadow-lg"
        />
      </div>
    </div>

    <!-- Additional Paragraphs -->
    <div class="flex flex-col space-y-4 mt-2 md:mt-4 lg:mt-4 max-w-4xl">
      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        The introduction of the DNSC-SIS genuinely changed the way we operated.
        It enables us to record, track, and create reports with just a few
        clicks, saving us a significant amount of time and effort. The system
        also reduced human mistakes because it automatically updates inventories
        and keeps data in real-time. The features like Inventory Management and
        the Reporting Module make it easier to monitor supplies and generate
        documents like Inspection and Acceptance Report (IAR), Requisition and
        Issue Slip (RIS), Inventory Custodian Slip (ICS), Property
        Acknowledgement Report (PAR), Report on the Physical Count of Property,
        Plant and Equipment (RPCPPE), Report of Supplies and Materials Issued
        (RSMI), and Report of Semi Expendable Property Issued (RSPI) whenever
        needed.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        Another feature that I truly appreciate is the Renewal and Transfer of
        items from one end-user to another, as well as the Return of items.
        Through this, all movements of property are properly recorded and
        monitored in the system. It also ensures that users are clear of their
        accountabilities once the items are officially returned or transferred.
        What’s even better is that we can easily view the status of the items
        issued to us, giving us transparency and peace of mind.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        I also appreciate the system's accessibility through mobile devices.
        This means that even while I’m away from the office, I may still use the
        SIS, especially when there is a need for approval and verification. This
        provides me with convenience and flexibility in managing and tracking
        supplies at any time and from anywhere.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        I also want to talk about how easy it is to use the SIS. I honestly
        believed that I would struggle to understand and use the system,
        considering my current age. As everyone is aware, older users may find
        it challenging to adjust to new technologies due to their complexity and
        crucial nature. But with DNSC-SIS, I was surprised at how easy it was to
        understand and navigate. The system is well-designed, simple, and clear,
        allowing users to operate it effectively.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        Overall, the DNSC-SIS has reduced stress and increased efficiency in our
        work in the Supply and Property Management Unit. Instead of spending too
        much time on manual paperwork, it enables us to produce real-time
        reports, better manage our time, and concentrate more on the actual
        management of supply and property. We proudly share our positive
        experience with the SIS, as it has become one of our best practices and
        a reliable tool in accomplishing our daily office tasks. I am happy to
        be among the end-users who are directly benefiting from this significant
        advancement for the College.
      </p>
    </div>

    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="mt-5 px-8 py-3 bg-white/20 backdrop-blur-md text-white font-semibold rounded-full border border-white/40 shadow-lg hover:bg-red-600 hover:text-white hover:border-red-600 transition duration-300 ease-in-out"
    >
      Close
    </button>
  </section>
</template>

<script>
export default {
  name: "JinnahFeedbackContent",
};
</script>

<style scoped>
/* ✅ Custom responsive spacing for the profile section */
.profile-section {
  margin-top: 122rem; /* default for mobile */
}

@media (min-width: 640px) {
  /* sm screens (small tablets, large phones) */
  .profile-section {
    margin-top: 8rem;
  }
}

@media (min-width: 768px) {
  /* md screens (tablets) */
  .profile-section {
    margin-top: 98rem;
  }
}

@media (min-width: 1024px) {
  /* lg screens (laptops/desktops) */
  .profile-section {
    margin-top: 6rem;
  }
}

@media (min-width: 1280px) {
  /* xl screens (large desktops) */
  .profile-section {
    margin-top: 33rem;
  }
}

/* Smooth scrollbar for overflow sections */
section::-webkit-scrollbar {
  width: 8px;
}
section::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
}
</style>
